import { Alert, Typography } from 'ui/mui';
import useNetworkStatus from '@/hooks/useNetworkStatus';

const NetworkStatusBanner = () => {
  const isOnline = useNetworkStatus();

  if (isOnline) {
    return null;
  }

  return (
    <Alert
      severity='warning'
      sx={{
        margin: '1rem',
      }}
    >
      <Typography variant='subtitle1' sx={{ fontWeight: 600 }}>
        Du är offline - en del information kan inte visas
      </Typography>
      <Typography variant='body2'>
        Kontrollera din nätverksanslutning
      </Typography>
    </Alert>
  );
};

export default NetworkStatusBanner;
